import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
} from 'chart.js';

import React from 'react';
import { Box } from '@mui/material';
import type { LineChartType } from '../../API/services/metricsService';

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale
);
type LineChartProps = {
  selectedPeriod: number | string;
  lineData: LineChartType;
  Manualheight?: number;
};

const LineChart: React.FC<LineChartProps> = ({
  selectedPeriod,
  lineData,
  Manualheight,
}) => {
  const getLineData = (selectedPeriod: number) => {
    switch (selectedPeriod) {
    case 1:
      return lineData['1W'].data;
    case 2:
      return lineData['1M'].data;
    case 3:
      return lineData['6M'].data;
    case 4:
      return lineData['1Y'].data;
    case 5:
      return lineData['5Y'].data;
    default:
      return [];
    }
  };

  const getLabels = () => {
    switch (Number(selectedPeriod)) {
    case 1:
      return lineData['1W'].labels;
    case 2:
      return lineData['1M'].labels;
    case 3:
      return lineData['6M'].labels;
    case 4:
      return lineData['1Y'].labels;
    case 5:
      return lineData['5Y'].labels;
    default:
      return [];
    }
  };

  const data = {
    labels: getLabels(),
    datasets: [
      {
        data: getLineData(Number(selectedPeriod)),
        borderWidth: 1,
        borderColor: '#03A3DB',
        tension: 0.1,
        pointRadius: 3,
        pointBackgroundColor: '#ffffff',
        pointBorderColor: '#03A3DB',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        backgroundColor: '#FBFDFF', // Custom tooltip background color
        titleColor: '#222222', // Title text color
        bodyColor: '#222222', // Body text color
        borderWidth: 1, // Border width
        cornerRadius: 8, // Rounded corners for a modern look
        borderColor: '#03A3DB', // Border color (instead of borderShadeColor)
        displayColors: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false, // Removes the Y-axis line
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          border: 0,
          display: true,
          drawBorder: false,
          borderDash: [5, 5],
          borderDashOffset: 0,
          color: 'rgba(150, 150, 150, 0.5)',
          lineWidth: 1,
          drawTicks: false,
        },
        border: {
          display: false, // Removes the Y-axis line
        },
        ticks: {
          padding: 10, // Add padding between the ticks and the axis line
        },
      },
    },
  };

  return (
    <Box className="pt-24 cursor-pointer">
      <Line data={data} options={options} height={Manualheight} />
    </Box>
  );
};
export default LineChart;
